import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { PageHeader, GlassCard } from "../_shared";
import { Button } from "@/components/ui/button";
import { RefreshCcw } from "lucide-react";

const COLORS = {
  create: "bg-emerald-100 text-emerald-700 border-emerald-200",
  update: "bg-blue-100 text-blue-700 border-blue-200",
  delete: "bg-red-100 text-red-700 border-red-200",
  reorder: "bg-amber-100 text-amber-700 border-amber-200",
};

export default function ActivityManager() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/cms/activity").then(r => setItems(r.data)).catch(e => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);

  return (
    <>
      <PageHeader
        title="Activity Log"
        subtitle="Latest 100 changes made in the admin console."
        actions={<Button variant="outline" onClick={load} className="rounded-full"><RefreshCcw className="w-4 h-4 mr-1.5" /> Refresh</Button>}
      />
      <GlassCard>
        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50">
              <TableHead>When</TableHead>
              <TableHead>User</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Entity</TableHead>
              <TableHead>Note</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 && (
              <TableRow><TableCell colSpan={5} className="text-center py-14 text-slate-500">No activity yet. Start editing content to see it here.</TableCell></TableRow>
            )}
            {items.map((it) => (
              <TableRow key={it.id}>
                <TableCell className="text-xs whitespace-nowrap">{new Date(it.created_at).toLocaleString()}</TableCell>
                <TableCell className="text-sm">{it.user_email}</TableCell>
                <TableCell><Badge className={`${COLORS[it.action] || "bg-slate-100 text-slate-700"} border capitalize font-medium`}>{it.action}</Badge></TableCell>
                <TableCell className="font-mono text-xs">{it.entity}</TableCell>
                <TableCell className="text-sm text-slate-600">{it.note || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </GlassCard>
    </>
  );
}
